import * as Sentry from "@sentry/nextjs"
import { AtlasNav, AtlasUserButton } from 'atlas-ds'
import AtlasMenu from 'atlas-menu'
import { EntrepriseContext } from 'pages/_app'
import { useContext, useEffect, useRef, useState } from 'react'
import { useAPIProfil, useAPIServices } from 'services/auth'
import { Entreprise } from "services/model"
import { useOidcSession } from 'services/useOidcSession'
import { getLogoutUrl } from 'services/oidc-config'
import { useOidc } from '@axa-fr/react-oidc'

export default function Nav() {
    const [_, setEntreprise] = useContext(EntrepriseContext)
    const { data: authSession } = useOidcSession()
    const { login, logout } = useOidc()
    const { data: profil } = useAPIProfil()
    const { data: services } = useAPIServices()
    const [menuIsOpen, setMenuIsOpen] = useState(false)
    const menu = useRef(null)
    const buttonRef = useRef(null)

    const onLogin = () => {
        sessionStorage.removeItem('loggingOut')
        login('login')
    }

    const defineEntreprise = (entreprise: Entreprise | null) => {
        setEntreprise(entreprise)
        Sentry.setContext("entreprise", {
            name: entreprise?.name,
            siret: entreprise?.siret,
            branche: entreprise?.branche?.valueName,
        })
    }


    useEffect(() => {
        if (!menu.current && services) {
            const handleLogout = async () => {
                if (authSession) {
                    localStorage.removeItem("currentCompany")
                    defineEntreprise(null)

                    sessionStorage.setItem('loggingOut', 'true')
                    
                    // Logout avec @axa-fr/react-oidc
                    await logout()
                    sessionStorage.removeItem('loggingOut')
                    
                    // Redirection vers le logout fédéré
                    if (authSession.idToken) {
                        window.location.href = getLogoutUrl(authSession.idToken)
                    } else {
                        window.location.href = '/'
                    }
                }
            }

            // See https://github.com/Service-SI-OPCO-Atlas/atlas-menu
            menu.current = new AtlasMenu({
                opener: buttonRef.current,
                onLogout: handleLogout,
                top: 26,
                onOpen: () => setMenuIsOpen(true),
                onClose: () => setMenuIsOpen(false),
                services: [
                    {
                        id: "my-fafiec-portail",
                        url: process.env.NEXT_PUBLIC_MENU_SERVICE_FAFIEC
                    },
                    ... services?.includes('ADH') ? [{
                        id: "sel-atlas",
                        url: process.env.NEXT_PUBLIC_MENU_SERVICE_ENTREPRISE
                    }] : [],
                    ... services?.includes('OF') ? [{
                        id: "sel-atlas-prestataire",
                        url: process.env.NEXT_PUBLIC_MENU_SERVICE_PRESTATAIRE
                    }] : [],
                    {
                        id: "campus",
                        isCurrentPage: true
                    },
                    {
                        id: "soa",
                        url: process.env.NEXT_PUBLIC_MENU_SERVICE_SOA
                    }
                ],
                parameters: [
                    {
                        id: "compte",
                        url: process.env.NEXT_PUBLIC_MENU_PARAM_COMPTE || null
                    }
                ]
            })
        }
    }, [authSession, services])

    return <AtlasNav
        userButton={<AtlasUserButton
            ref={buttonRef}
            userName={profil ? `${profil?.firstName} ${profil?.lastName}` : undefined}
            onClick={authSession ? undefined : onLogin}
            open={menuIsOpen}
        />}
    />
}
